<ziro-text fieldId="hostAddress"></ziro-text>
<ziro-radio fieldId="protocol"></ziro-radio>
<ziro-text fieldId="port"></ziro-text>
